import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["dataTestId", "isOpen", "className", "modifierClassName", "variant"],
  _excluded2 = ["children", "dataTestId", "isOpen", "className", "fancy", "mobileFullscreen", "noPadding", "scrollable", "variant"];
var _class;
var __jsx = React.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { space, textAlign, width, color, alignItems, justifyContent, flexDirection, top, border } from 'styled-system';
import { mediaQueries } from 'shared/styles';
var ReactModalAdapter = observer(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ReactModalAdapter, _React$Component);
  var _super = _createSuper(ReactModalAdapter);
  function ReactModalAdapter() {
    var _this;
    _classCallCheck(this, ReactModalAdapter);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "targetRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "onModalOpen", function () {
      disableBodyScroll(_this.targetRef);
    });
    _defineProperty(_assertThisInitialized(_this), "onModalClose", function () {
      var onRequestClose = _this.props.onRequestClose;
      enableBodyScroll(_this.targetRef);
      if (onRequestClose) {
        onRequestClose.apply(void 0, arguments);
      }
    });
    return _this;
  }
  _createClass(ReactModalAdapter, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      try {
        enableBodyScroll(this.targetRef);
      } catch (e) {
        // console.error(e); // swallow error that occurs when
        // navigating between pages and a modal is open.
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        dataTestId = _this$props.dataTestId,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        modifierClassName = _this$props.modifierClassName,
        variant = _this$props.variant,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var testId = dataTestId || rest['data-testid'];
      var contentClassName = "".concat(className, "__content ").concat(modifierClassName);
      var overlayClassName = "".concat(className, "__overlay");

      // Add data-testid to the content class if it exists
      if (testId) {
        contentClassName = "".concat(contentClassName, " modal-content-").concat(testId);
      }
      if (variant === 'embedded') {
        contentClassName += ' --variant-embedded';
        overlayClassName += ' --variant-embedded';
      }
      if (variant === 'admin-scrollable') {
        contentClassName += ' --variant-admin-scrollable';
        overlayClassName += ' --variant-admin-scrollable';
      }
      if (variant === 'admin-scrollable-dynamic') {
        contentClassName += ' --variant-admin-scrollable --dynamic';
        overlayClassName += ' --variant-admin-scrollable --dynamic';
      }
      if (variant === 'mobile-vertical-scroll') {
        contentClassName += ' --mobile-vertical-scroll';
      }
      return __jsx(Modal, _extends({
        "data-testid": dataTestId,
        isOpen: isOpen,
        className: contentClassName,
        contentLabel: "Dutchie Modal",
        contentRef: function contentRef(node) {
          _this2.targetRef = node;
          if (node && testId) {
            node.setAttribute('data-testid', testId);
          }
        },
        onAfterOpen: this.onModalOpen,
        onRequestClose: this.onModalClose,
        overlayClassName: "".concat(overlayClassName, " ios-hack"),
        portalClassName: className
      }, rest, {
        data: {
          cy: rest['data-cy'],
          test: rest['data-test']
        }
      }));
    }
  }]);
  return ReactModalAdapter;
}(React.Component)) || _class;
var StyledModal = styled(ReactModalAdapter).withConfig({
  displayName: "container__StyledModal",
  componentId: "sc-1ed10rm-0"
})(["&__overlay{position:fixed;top:0px;left:0px;right:0px;bottom:0px;background-color:rgba(62,68,73,0.93);z-index:", ";pointer-events:auto;&.--variant-embedded{background-color:rgba(255,255,255,0.95);}body.--ios-hack--repaint &{transform:translateZ(0);-moz-transform:translatez(0);-ms-transform:translatez(0);-o-transform:translatez(0);-webkit-transform:translateZ(0);-webkit-overflow-scrolling:touch;touch-action:auto;-webkit-user-select:none;-webkit-touch-callout:none;-webkit-user-drag:none;}", "}&__content{padding:", ";border-radius:8px;box-shadow:0 5px 5px rgba(0,0,0,0.11);background-color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;position:absolute;box-sizing:border-box;outline:none;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " &.--variant-embedded{box-shadow:none;border:1px solid #c9cdd4;top:40px;position:absolute;left:50%;transform:translate(-50%,0%);}&.--variant-admin-scrollable{max-height:none;height:100%;&.--dynamic{max-height:100%;height:unset;", "}}&.--product-modal{background:transparent;box-shadow:none;border:none;height:100vh;width:1140px;max-width:80vw;margin:0 auto;display:flex;flex-direction:column;max-height:unset;position:unset;transform:unset;border-radius:0;@media ", "{background-color:white;max-width:100vw;}@media ", "{max-height:100%;height:100%;width:100%;top:0;left:0;transform:none;border-radius:0px;justify-content:flex-start;position:static;}}&.--dutchie-video-modal{@media ", "{display:flex;align-items:center;justify-content:center;background-color:transparent;}}&.--mobile-vertical-scroll{overflow-y:scroll;display:block;}}", " ", ""], function (_ref) {
  var important = _ref.important;
  return important ? 500 : 100;
}, function (props) {
  return props.scrollable && "\n      align-items: center;\n      display: flex;\n      justify-content: center;\n    ";
}, function (props) {
  if (props.fancy) {
    return '101px 47px 45px 47px';
  }
  if (props.noPadding) {
    return '0px';
  }
  if (props.sidePadding) {
    return '31px 5px 45px 5px';
  }
  return props.padding || '31px 47px 45px 47px';
}, function (props) {
  return !props.popUp && "\n      max-height: 100vh;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    ";
}, function (props) {
  return props.popUp && "\n      max-height: calc(100vh - 20px);\n      bottom: 0px;\n      left: 50%;\n      transform: translate(-50%, 0);\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n    ";
}, space, textAlign, width, color, alignItems, justifyContent, flexDirection, border, function (props) {
  return props.scrollable && "\n      position: relative;\n      display: inline-flex;\n      transform: none;\n      left: auto;\n      top: auto;\n    ";
}, top, mediaQueries.tablet, mediaQueries.largePhone, mediaQueries.largePhone, function (props) {
  return props.mobileFullscreen && "\n    @media ".concat(mediaQueries.largePhone, " {\n      &__content, &__content.--variant-embedded {\n        max-height: 100%;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        transform: none;\n        border-radius: 0px;\n        justify-content: flex-start;\n        overflow: scroll;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n  ");
}, function (props) {
  return props.mobileCentered && "\n    @media ".concat(mediaQueries.largePhone, " {\n      &__content, &__content.--variant-embedded {\n        max-height: 100%;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        transform: none;\n        border-radius: 0px;\n        justify-content: center;\n        overflow: scroll;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n  ");
});
export default (function (props) {
  var children = props.children,
    dataTestId = props.dataTestId,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
    modifierClassName = props.className,
    _props$fancy = props.fancy,
    fancy = _props$fancy === void 0 ? false : _props$fancy,
    _props$mobileFullscre = props.mobileFullscreen,
    mobileFullscreen = _props$mobileFullscre === void 0 ? true : _props$mobileFullscre,
    _props$noPadding = props.noPadding,
    noPadding = _props$noPadding === void 0 ? false : _props$noPadding,
    _props$scrollable = props.scrollable,
    scrollable = _props$scrollable === void 0 ? false : _props$scrollable,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    rest = _objectWithoutProperties(props, _excluded2);
  useEffect(function () {
    // react-modal adds a pesky overflow: hidden to the body, so we unset
    // it when the modal is closed to ensure the user can still scroll
    if (!isOpen) {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);
  return __jsx(StyledModal, _extends({}, rest, {
    "data-testid": dataTestId,
    fancy: fancy,
    mobileFullscreen: mobileFullscreen,
    modifierClassName: modifierClassName,
    noPadding: noPadding,
    scrollable: scrollable,
    variant: variant,
    isOpen: isOpen
  }), children);
});